﻿import { ComboboxEditor, Decorators, EditorProps, EditorUtils, findElementWithRelativeId, getRemoteData, trimToNull, tryGetWidget, Widget } from "@serenity-is/corelib";
import { RowServiceColumnItem } from "@/ServerTypes/RowServiceColumnItem";
import { nsMatrix } from "@/Namespaces";

export class EntityTypeEditor extends ComboboxEditor<any, RowServiceColumnItem> {
    static override[Symbol.typeInfo] = this.registerEditor(nsMatrix);

    protected data: RowServiceColumnItem[] = [];

    constructor(opt: EditorProps<ComboboxEditor<any, RowServiceColumnItem>>) {
        super({...opt, autoComplete: true });

        this.data = (getRemoteData("RowServiceColumnData") as RowServiceColumnItem[]);

        for (const item of this.data)
            this.addOption(item.RowCode, item.RowDisplayName, item);

        this.changeSelect2(() => this.updateColumnsKeyAndServiceEditors());
    }

    protected updateColumnsKeyAndServiceEditors() {
        const selectedItem = this.selectedItem;
        if (!selectedItem)
            return;

        if (selectedItem.Services.length > 0) {
            const editor = tryGetWidget(findElementWithRelativeId(this.domNode, "service"), Widget);
            editor && EditorUtils.setValue(editor, selectedItem.Services[0]);
        }

        if (selectedItem.ColumnKeys.length > 0) {
            const editor = tryGetWidget(findElementWithRelativeId(this.domNode, "columnsKey"), Widget);
            editor && EditorUtils.setValue(editor, selectedItem.ColumnKeys[0]);
        }

        if (trimToNull(selectedItem.IdFieldName) != null) {
            const editor = tryGetWidget(findElementWithRelativeId(this.domNode, "idField"), Widget);
            editor && EditorUtils.setValue(editor, selectedItem.IdFieldName);
        }

        if (trimToNull(selectedItem.TextFieldName) != null) {
            const editor = tryGetWidget(findElementWithRelativeId(this.domNode, "textField"), Widget);
            editor && EditorUtils.setValue(editor, selectedItem.TextFieldName);
        }
    }
}